// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"8":"mobile","380":"desktop"}[chunkId] || chunkId) + "." + {"8":"b24211e1","58":"676ceb57","380":"283b4b94","495":"451fed25","536":"7f9c99ca"}[chunkId] + ".chunk.js";
};